import { ErrorDisplayTypeEnum, MessageEnum } from '@/modules/core/models/enums'
import ModalButton from '../modalMessage/ModalButton'

const DEFAULT_DISPLAY_TYPE = ErrorDisplayTypeEnum.NONE
const DEFAULT_TITLE = ''
const DEFAULT_MODAL_DESCRIPTION = ''
const DEFAULT_MODAL_BUTTONS = [new ModalButton({ text: 'copy_button_return', navTo: 'rater-nav' })]

export default class CustomError extends Error {
  // * Tipo de error
  type: MessageEnum.ERROR | MessageEnum.WARNING
  // * Nombre/ruta del servicio que ha fallado
  serviceName?: string | null
  // * Tipo de visualizacion del error
  displayType: ErrorDisplayTypeEnum
  // * Mensaje para el toast / Mensaje para el modal
  title: string
  // * Descripcion para el modal
  modalDescription?: string
  // * Objeto extra para el modal
  extra?: { [key: string]: any }
  // * Bottones para el modal
  buttons?: ModalButton[]

  constructor(error: Partial<CustomError>) {
    // * Mensaje del error interno
    super(error.message)
    // * Nombre de la entidad del error
    this.name = this.constructor.name
    this.type = error.type ?? MessageEnum.ERROR
    this.serviceName = error?.serviceName ?? null
    this.displayType = error?.displayType ?? DEFAULT_DISPLAY_TYPE
    this.title = error?.title ?? DEFAULT_TITLE
    this.modalDescription = error?.modalDescription ?? DEFAULT_MODAL_DESCRIPTION
    this.extra = error?.extra ?? {}
    this.buttons = error?.buttons ?? DEFAULT_MODAL_BUTTONS

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }

  setMessage(message: string) {
    this.message = message
    return this
  }

  setType(type: MessageEnum.ERROR | MessageEnum.WARNING) {
    this.type = type
    return this
  }

  setDisplayType(displayType: ErrorDisplayTypeEnum) {
    this.displayType = displayType
    return this
  }

  setTitle(title: string) {
    this.title = title
    return this
  }

  setModalDescription(description: string) {
    this.modalDescription = description
    return this
  }

  setButtons(buttons: ModalButton[]) {
    this.buttons = buttons
    return this
  }

  setExtra(extra: { [key: string]: any }) {
    this.extra = extra
    return this
  }

  // * Configuracion que se le pasa a la modal
  get modalConfiguration() {
    return {
      title: this.title,
      label: this.modalDescription,
      buttons: this.buttons,
      extra: this.extra
    }
  }
}
